import React from "react";
import { motion } from "framer-motion";

interface PulsatingGlowTagProps {
  children: React.ReactNode;
  className?: string;
}

const PulsatingGlowTag: React.FC<PulsatingGlowTagProps> = ({ children, className = "" }) => (
  <motion.span
    className={`inline-block px-6 py-2 rounded-full bg-white text-[#2D7D46] text-lg md:text-xl font-extrabold shadow-lg border-2 border-[#2D7D46] ${className}`}
    style={{ boxShadow: "0 0 0 4px #2D7D4622, 0 4px 24px #2D7D4699" }}
    animate={{
      boxShadow: [
        "0 0 0 4px #2D7D4622, 0 4px 24px #2D7D4699",
        "0 0 0 12px #2D7D4622, 0 4px 32px #2D7D46cc",
        "0 0 0 4px #2D7D4622, 0 4px 24px #2D7D4699",
      ],
      scale: [1, 1.07, 1],
    }}
    transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
  >
    {children}
  </motion.span>
);

export default PulsatingGlowTag;
